// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AdminCegadatApiController from "./admin_cegadat_api_controller"
application.register("admin-cegadat-api", AdminCegadatApiController)

import AdminSubscriberContractController from "./admin_subscriber_contract_controller"
application.register("admin-subscriber-contract", AdminSubscriberContractController)

import AiChartsController from "./ai_charts_controller"
application.register("ai-charts", AiChartsController)

import AiController from "./ai_controller"
application.register("ai", AiController)

import AiStatsController from "./ai_stats_controller"
application.register("ai-stats", AiStatsController)

import AlertController from "./alert_controller"
application.register("alert", AlertController)

import AnalyticsController from "./analytics_controller"
application.register("analytics", AnalyticsController)

import AreaCodeController from "./area_code_controller"
application.register("area-code", AreaCodeController)

import AssociateModalController from "./associate_modal_controller"
application.register("associate-modal", AssociateModalController)

import AuditEventsFilterController from "./audit_events_filter_controller"
application.register("audit-events-filter", AuditEventsFilterController)

import AutocompleteController from "./autocomplete_controller"
application.register("autocomplete", AutocompleteController)

import AutogrowController from "./autogrow_controller"
application.register("autogrow", AutogrowController)

import AvatarController from "./avatar_controller"
application.register("avatar", AvatarController)

import AvatarPickerController from "./avatar_picker_controller"
application.register("avatar-picker", AvatarPickerController)

import BeaconController from "./beacon_controller"
application.register("beacon", BeaconController)

import BsController from "./bs_controller"
application.register("bs", BsController)

import BuildingComplexPrefixController from "./building_complex_prefix_controller"
application.register("building-complex-prefix", BuildingComplexPrefixController)

import CalendarController from "./calendar_controller"
application.register("calendar", CalendarController)

import ChatDockController from "./chat_dock_controller"
application.register("chat-dock", ChatDockController)

import ChatDockReactWrapController from "./chat_dock_react_wrap_controller"
application.register("chat-dock-react-wrap", ChatDockReactWrapController)

import ChatMemberSelectController from "./chat_member_select_controller"
application.register("chat-member-select", ChatMemberSelectController)

import ChatOpenRoomController from "./chat_open_room_controller"
application.register("chat-open-room", ChatOpenRoomController)

import ChatReactWrapController from "./chat_react_wrap_controller"
application.register("chat-react-wrap", ChatReactWrapController)

import ClickableLinkController from "./clickable_link_controller"
application.register("clickable-link", ClickableLinkController)

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import CallCenterWidgetController from "./call_center_widget_controller"
application.register("call-center-widget", CallCenterWidgetController)

import CompanyActivitiesController from "./company_activities_controller"
application.register("company-activities", CompanyActivitiesController)

import CompanyCegadatApiController from "./company_cegadat_api_controller"
application.register("company-cegadat-api", CompanyCegadatApiController)

import CompanyTasksFilterController from "./company_tasks_filter_controller"
application.register("company-tasks-filter", CompanyTasksFilterController)

import CoordinatesMapController from "./coordinates_map_controller"
application.register("coordinates-map", CoordinatesMapController)

import DashboardChartsController from "./dashboard_charts_controller"
application.register("dashboard-charts", DashboardChartsController)

import DocEditorController from "./doc_editor_controller"
application.register("doc-editor", DocEditorController)

import DragController from "./drag_controller"
application.register("drag", DragController)

import DriveController from "./drive_controller"
application.register("drive", DriveController)

import DriveToolbarController from "./drive_toolbar_controller"
application.register("drive-toolbar", DriveToolbarController)

import EditorController from "./editor_controller"
application.register("editor", EditorController)

import EditorjsController from "./editorjs_controller"
application.register("editorjs", EditorjsController)

import EhazHouseSelectionController from "./ehaz_house_selection_controller"
application.register("ehaz-house-selection", EhazHouseSelectionController)

import EhazSyncController from "./ehaz_sync_controller"
application.register("ehaz-sync", EhazSyncController)

import EhazUnlinkController from "./ehaz_unlink_controller"
application.register("ehaz-unlink", EhazUnlinkController)

import EmailBodyImagesController from "./email_body_images_controller"
application.register("email-body-images", EmailBodyImagesController)

import EmailBulkController from "./email_bulk_controller"
application.register("email-bulk", EmailBulkController)

import EmailComposeController from "./email_compose_controller"
application.register("email-compose", EmailComposeController)

import EmailController from "./email_controller"
application.register("email", EmailController)

import EmailDragController from "./email_drag_controller"
application.register("email-drag", EmailDragController)

import EmailKeyboardController from "./email_keyboard_controller"
application.register("email-keyboard", EmailKeyboardController)

import EmailLayoutController from "./email_layout_controller"
application.register("email-layout", EmailLayoutController)

import EmailListController from "./email_list_controller"
application.register("email-list", EmailListController)

import EmailReplyFormController from "./email_reply_form_controller"
application.register("email-reply-form", EmailReplyFormController)

import EmailRuleBuilderController from "./email_rule_builder_controller"
application.register("email-rule-builder", EmailRuleBuilderController)

import EmailSearchController from "./email_search_controller"
application.register("email-search", EmailSearchController)

import EmailSidebarController from "./email_sidebar_controller"
application.register("email-sidebar", EmailSidebarController)

import EmailStatsChartController from "./email_stats_chart_controller"
application.register("email-stats-chart", EmailStatsChartController)

import EmailTagController from "./email_tag_controller"
application.register("email-tag", EmailTagController)

import EmailTagPickerController from "./email_tag_picker_controller"
application.register("email-tag-picker", EmailTagPickerController)

import EmailTaskPickerController from "./email_task_picker_controller"
application.register("email-task-picker", EmailTaskPickerController)

import EmailThreadController from "./email_thread_controller"
application.register("email-thread", EmailThreadController)

import EquipmentCascadingSelectController from "./equipment_cascading_select_controller"
application.register("equipment-cascading-select", EquipmentCascadingSelectController)

import FileGroupController from "./file_group_controller"
application.register("file-group", FileGroupController)

import FilePreviewController from "./file_preview_controller"
application.register("file-preview", FilePreviewController)

import FileUploadController from "./file_upload_controller"
application.register("file-upload", FileUploadController)

import FocusOnController from "./focus_on_controller"
application.register("focus-on", FocusOnController)

import GlobalsearchController from "./globalsearch_controller"
application.register("globalsearch", GlobalsearchController)

import GuideSiteBuildPollerController from "./guide_site_build_poller_controller"
application.register("guide-site-build-poller", GuideSiteBuildPollerController)

import HashTabController from "./hash_tab_controller"
application.register("hash-tab", HashTabController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import ImportController from "./import_controller"
application.register("import", ImportController)

import LayoutController from "./layout_controller"
application.register("layout", LayoutController)

import LazyHighlightController from "./lazy_highlight_controller"
application.register("lazy-highlight", LazyHighlightController)

import LoadingBarController from "./loading_bar_controller"
application.register("loading-bar", LoadingBarController)

import LottieFilesController from "./lottie_files_controller"
application.register("lottie-files", LottieFilesController)

import MailboxVerifyController from "./mailbox_verify_controller"
application.register("mailbox-verify", MailboxVerifyController)

import MailboxWizardController from "./mailbox_wizard_controller"
application.register("mailbox-wizard", MailboxWizardController)

import MarkdownController from "./markdown_controller"
application.register("markdown", MarkdownController)

import MediaCaptureController from "./media_capture_controller"
application.register("media-capture", MediaCaptureController)

import MentionsController from "./mentions_controller"
application.register("mentions", MentionsController)

import MessengerChartsController from "./messenger_charts_controller"
application.register("messenger-charts", MessengerChartsController)

import MiniChartsController from "./mini_charts_controller"
application.register("mini-charts", MiniChartsController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import NavTabsController from "./nav_tabs_controller"
application.register("nav-tabs", NavTabsController)

import NotificationsController from "./notifications_controller"
application.register("notifications", NotificationsController)

import PackageDeliveryAutocompleteController from "./package_delivery_autocomplete_controller"
application.register("package-delivery-autocomplete", PackageDeliveryAutocompleteController)

import PackageRecipientAutocompleteController from "./package_recipient_autocomplete_controller"
application.register("package-recipient-autocomplete", PackageRecipientAutocompleteController)

import PackageStatsController from "./package_stats_controller"
application.register("package-stats", PackageStatsController)

import PatrolController from "./patrol_controller"
application.register("patrol", PatrolController)

import PatrolFilePreviewController from "./patrol_file_preview_controller"
application.register("patrol-file-preview", PatrolFilePreviewController)

import PeopleController from "./people_controller"
application.register("people", PeopleController)

import PersonGroupController from "./person_group_controller"
application.register("person-group", PersonGroupController)

import PersonalMailboxFormController from "./personal_mailbox_form_controller"
application.register("personal-mailbox-form", PersonalMailboxFormController)

import PhotoswipeController from "./photoswipe_controller"
application.register("photoswipe", PhotoswipeController)

import PickupModalController from "./pickup_modal_controller"
application.register("pickup-modal", PickupModalController)

import PopoverController from "./popover_controller"
application.register("popover", PopoverController)

import PostcodeController from "./postcode_controller"
application.register("postcode", PostcodeController)

import PropertyManagerBreadcrumbsController from "./property_manager_breadcrumbs_controller"
application.register("property-manager-breadcrumbs", PropertyManagerBreadcrumbsController)

import PropertyManagerController from "./property_manager_controller"
application.register("property-manager", PropertyManagerController)

import PulltorefreshController from "./pulltorefresh_controller"
application.register("pulltorefresh", PulltorefreshController)

import QuoteRequestController from "./quote_request_controller"
application.register("quote-request", QuoteRequestController)

import QuoteSubmissionController from "./quote_submission_controller"
application.register("quote-submission", QuoteSubmissionController)

import RefreshController from "./refresh_controller"
application.register("refresh", RefreshController)

import ReportTaskWorkflowController from "./report_task_workflow_controller"
application.register("report-task-workflow", ReportTaskWorkflowController)

import ResidentReportBreadcrumbsController from "./resident-report-breadcrumbs_controller"
application.register("resident-report-breadcrumbs", ResidentReportBreadcrumbsController)

import ResidentReportController from "./resident_report_controller"
application.register("resident-report", ResidentReportController)

import SearchResultsController from "./search_results_controller"
application.register("search-results", SearchResultsController)

import SearchScopeDropdownController from "./search_scope_dropdown_controller"
application.register("search-scope-dropdown", SearchScopeDropdownController)

import SecurityServicesPatrolsRoadController from "./security_services_patrols_road_controller"
application.register("security-services-patrols-road", SecurityServicesPatrolsRoadController)

import ServiceProviderLogController from "./service_provider_log_controller"
application.register("service-provider-log", ServiceProviderLogController)

import ShowMoreController from "./show_more_controller"
application.register("show-more", ShowMoreController)

import SubscriptionChartsController from "./subscription_charts_controller"
application.register("subscription-charts", SubscriptionChartsController)

import SupportLayoutController from "./support_layout_controller"
application.register("support-layout", SupportLayoutController)

import SupportReplyController from "./support_reply_controller"
application.register("support-reply", SupportReplyController)

import TableController from "./table_controller"
application.register("table", TableController)

import TaskBreadcrumbsController from "./task_breadcrumbs_controller"
application.register("task-breadcrumbs", TaskBreadcrumbsController)

import TaskCalendarVisibilityController from "./task_calendar_visibility_controller"
application.register("task-calendar-visibility", TaskCalendarVisibilityController)

import TaskController from "./task_controller"
application.register("task", TaskController)

import TaskFormController from "./task_form_controller"
application.register("task-form", TaskFormController)

import TaskKanbanController from "./task_kanban_controller"
application.register("task-kanban", TaskKanbanController)

import TaskModalController from "./task_modal_controller"
application.register("task-modal", TaskModalController)

import TaskPeopleController from "./task_people_controller"
application.register("task-people", TaskPeopleController)

import TaskPersonGroupsController from "./task_person_groups_controller"
application.register("task-person-groups", TaskPersonGroupsController)

import TaskScheduleController from "./task_schedule_controller"
application.register("task-schedule", TaskScheduleController)

import TaskTagController from "./task_tag_controller"
application.register("task-tag", TaskTagController)

import TechnicalSpecsController from "./technical_specs_controller"
application.register("technical-specs", TechnicalSpecsController)

import TextHighlightController from "./text_highlight_controller"
application.register("text-highlight", TextHighlightController)

import TimelineController from "./timeline_controller"
application.register("timeline", TimelineController)

import TinymceController from "./tinymce_controller"
application.register("tinymce", TinymceController)

import VoiceAssistantChartsController from "./voice_assistant_charts_controller"
application.register("voice-assistant-charts", VoiceAssistantChartsController)

import VoiceAssistantNavController from "./voice_assistant_nav_controller"
application.register("voice-assistant-nav", VoiceAssistantNavController)

import VoiceChartsController from "./voice_charts_controller"
application.register("voice-charts", VoiceChartsController)

import VoiceDictateController from "./voice_dictate_controller"
application.register("voice-dictate", VoiceDictateController)

import WebdavStatsChartsController from "./webdav_stats_charts_controller"
application.register("webdav-stats-charts", WebdavStatsChartsController)

import WebpushController from "./webpush_controller"
application.register("webpush", WebpushController)

import WorkflowController from "./workflow_controller"
application.register("workflow", WorkflowController)

import WorkflowRunDetailPollerController from "./workflow_run_detail_poller_controller"
application.register("workflow-run-detail-poller", WorkflowRunDetailPollerController)

import WorkflowRunsPollerController from "./workflow_runs_poller_controller"
application.register("workflow-runs-poller", WorkflowRunsPollerController)

import IvrFlowDesignerController from "./ivr_flow_designer_controller"
application.register("ivr-flow-designer", IvrFlowDesignerController)
